module.exports = __webpack_public_path__ + "static/hero-scheduling-6699d9e23a097ec237bcab504b84c811.svg";